var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-modal-list-item-image"},[(_vm.image)?_c('app-image',{staticClass:"cart-modal-list-item-image__img",attrs:{"src":_vm.image,"alt":_vm.item.title}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }